module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/register-keyvisual_en_pc-e6b849f6ef30dfb4843072d1e5776c65.png";